import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalContext } from "@notanumber/nan-component-library";
import { API } from "API/API";
import LoginForm from "components/Login/LoginForm/LoginForm";
import ValidateForm from "components/Login/ValidateForm/ValidateForm";
import { useRouter } from "next/navigation";
import { faRightToBracket } from "@fortawesome/pro-regular-svg-icons";
import { useContext, useState } from "react";
import { setCookie } from "hooks/utils/cookies";
import { Constants } from "constants/constants";

const DealerLoginOverlay = ({ dealerIsLoggedIn }) => {
  const { closeOverlay } = useContext(ModalContext);
  const [loginError, setLoginError] = useState(null);
  const [validateError, setValidateError] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [currentStep, setCurrentStep] = useState(dealerIsLoggedIn ? "loggedIn" : "login");
  const router = useRouter();

  const steps = {
    login: (
      <>
        <p className="mb-6">
          Login als dealer, hierdoor zie jij in de webshop direct de advies verkoopprijs van onze producten.
          Daarnaast zien we bij een aanvraag direct dat deze door jouw is uitgevoerd.
        </p>
        <LoginForm
          dark={true}
          onSubmit={async (e) => {
            e.preventDefault();
            const email = e?.target?.email?.value;
            setUserEmail(email);

            const response = await API.login.send_code(
              email
            );

            if (response?.success) {
              setCurrentStep("validate");
              return;
            }

            setLoginError(response?.result?.message || "Er is een fout opgetreden");
            setTimeout(() => {
              setLoginError(null);
            }, 7000);
          }}
        />
      </>
    ),
    validate: (
      <>
        <p className="mb-6">
          We hebben zojuist een zes-cijferige verificatiecode gestuurd naar jouw e-mailadres. Vul deze hieronder in.
          Geen e-mail ontvangen? Wacht dan 10 minuten. Lukt het nog niet? Neem dan contact op.
        </p>
        <ValidateForm
          onSubmit={async ({ code }) => {
            const response = await API.login.validate(userEmail, code);
            if (response?.success) {
              const { token, expires_at } = response?.data || {};
              setCookie(
                Constants?.login_cookie,
                token,
                expires_at,
                Constants?.frontend_url
              );

              router.refresh();
              closeOverlay();
            } else {
              setValidateError(response?.result?.message || "Er is een fout opgetreden.");
              setTimeout(() => {
                setValidateError(null);
              }, 7000);
            }
          }}
        />
      </>
    ),
    loggedIn: (
      <>
        <p className="mb-6">
          Login als dealer, hierdoor zie jij in de webshop direct de advies verkoopprijs van onze producten.
          Daarnaast zien we bij een aanvraag direct dat deze door jouw is uitgevoerd.
        </p>
        <div className="flex flex-col gap-4 px-4 py-3 transition-all duration-300 min-h-12 bg-body rounded-5">
          <div className="flex items-center gap-3">
            <FontAwesomeIcon icon={faRightToBracket} className={`w-auto h-5 transition-all duration-300 rotate-180`} />
            <button
              className="font-semibold underline cursor-pointer text-dark-text"
              onClick={async () => {
                const response = await API.login.user.logout();
                if (response?.success) {
                  removeCookie(Constants?.login_cookie);
                  useForm.current.reset();
                  router.refresh();
                  closeOverlay();
                }
              }}
            >
              Klik hier om uit te loggen
            </button>
          </div>
        </div>
      </>
    ),
  }

  return (
    <div className="px-10 py-16 w-full !max-w-[36rem]">
      <h3>Login als dealer</h3>
      {steps[currentStep]}
      {(loginError || validateError) && (
        <div className="mt-2 text-base text-red-500">
          {loginError || validateError}
        </div>
      )}
    </div>
  )
}

export default DealerLoginOverlay